
import { useLocation } from '@reach/router';
export const searchParamsToLinkFormat = searchParameters => {
  const newParams = { ...searchParameters };
  const location = useLocation();
  newParams.url = location?.search ? location.pathname  + location.search : location.pathname;
  console.log({ newParams });
  return typeof window !== 'undefined' ? window?.btoa(JSON.stringify(newParams)) : '';
};
export default searchParamsToLinkFormat;